import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';

/**************************************************************************************************/
/*   File: /src/app/shared/interceptors/cache.interceptor.ts                                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wed July 24th 2019                                                             */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Jul 31 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Injectable } from '@angular/core';

/**
 * The interceptor that disable cache
 */
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    /**
     * Intercept the request disabling cache
     * @param req The reguest
     * @param next the handler
     */
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const httpRequest = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
                'X-NewPlan-Req-Env': 'Portal'
            }
        });

        return next.handle(httpRequest);
    }
}